import classnames from "classnames";
import { ReactNode } from "react";

import { Box, useBreakpoint, useForegroundVariantColor } from "@seneca/senekit";

import styles from "./TabBar.module.scss";

const TAB_BAR_HEIGHT = 56;
const TAB_BAR_MARGIN_Y = 8;
export const TAB_BAR_HEIGHT_WITH_MARGINS =
  TAB_BAR_HEIGHT + 2 * TAB_BAR_MARGIN_Y;

type TabBarHorizontalProps = {
  children?: ReactNode;
};

export function TabBarHorizontal({ children }: TabBarHorizontalProps) {
  const foregroundVariantColor = useForegroundVariantColor("1");

  return (
    <Box
      backgroundColor={foregroundVariantColor}
      borderRadius="medium"
      width="288px"
      height={`${TAB_BAR_HEIGHT}px`}
      marginY="large"
      marginX="auto"
      className={styles.horizontal}
    >
      {children}
    </Box>
  );
}

type TabBarResponsiveProps = {
  className?: string;
  children?: ReactNode;
};

export function TabBarResponsive({
  className,
  children
}: TabBarResponsiveProps) {
  const { isMobileOnly } = useBreakpoint();

  return (
    <div
      className={classnames(
        className,
        styles.responsive,
        isMobileOnly ? styles.isMobileOnly : ""
      )}
    >
      {children}
    </div>
  );
}
